import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-the-c01-detail" }
const _hoisted_2 = { class: "p-the-c01-detail__section" }
const _hoisted_3 = { class: "p-the-c01-detail__section" }
const _hoisted_4 = { class: "p-the-c01-detail__details" }
const _hoisted_5 = { class: "p-the-c01-detail__details__text" }
const _hoisted_6 = {
  key: 0,
  class: "p-the-c01-detail__details__text"
}
const _hoisted_7 = {
  key: 1,
  class: "p-the-c01-detail__details__text"
}
const _hoisted_8 = {
  key: 2,
  class: "p-the-c01-detail__details__category"
}
const _hoisted_9 = { class: "p-the-c01-detail__details__text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextSanitized = _resolveComponent("TextSanitized")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("p", { class: "p-the-c01-detail__section__title" }, "商品説明", -1)),
      (_ctx.commentIndex)
        ? (_openBlock(), _createBlock(_component_TextSanitized, {
            key: 0,
            text: _ctx.commentIndex,
            class: "p-the-c01-detail__section__comment"
          }, null, 8, ["text"]))
        : _createCommentVNode("", true),
      (_ctx.commentDetailMain)
        ? (_openBlock(), _createBlock(_component_TextSanitized, {
            key: 1,
            text: _ctx.commentDetailMain,
            class: "p-the-c01-detail__section__comment"
          }, null, 8, ["text"]))
        : _createCommentVNode("", true),
      (_ctx.commentDetailSub)
        ? (_openBlock(), _createBlock(_component_TextSanitized, {
            key: 2,
            text: _ctx.commentDetailSub,
            class: "p-the-c01-detail__section__comment"
          }, null, 8, ["text"]))
        : _createCommentVNode("", true),
      (_ctx.commentDetailSubSecond)
        ? (_openBlock(), _createBlock(_component_TextSanitized, {
            key: 3,
            text: _ctx.commentDetailSubSecond,
            class: "p-the-c01-detail__section__comment"
          }, null, 8, ["text"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _cache[3] || (_cache[3] = _createElementVNode("p", { class: "p-the-c01-detail__section__title" }, "商品詳細", -1)),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", _hoisted_5, "JAN: " + _toDisplayString(_ctx.janCode), 1),
        (_ctx.saleStartDate)
          ? (_openBlock(), _createElementBlock("p", _hoisted_6, " 販売開始日: " + _toDisplayString(_ctx.saleStartDate), 1))
          : _createCommentVNode("", true),
        (_ctx.saleEndDate)
          ? (_openBlock(), _createElementBlock("p", _hoisted_7, " 販売終了日: " + _toDisplayString(_ctx.saleEndDate), 1))
          : _createCommentVNode("", true),
        (_ctx.category)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _cache[2] || (_cache[2] = _createElementVNode("p", { class: "p-the-c01-detail__details__text" }, "カテゴリ", -1)),
              _createElementVNode("p", _hoisted_9, [
                _createElementVNode("span", null, _toDisplayString(_ctx.category), 1),
                (_ctx.categoryChild)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _cache[1] || (_cache[1] = _createElementVNode("span", null, ">", -1)),
                      _createElementVNode("span", null, _toDisplayString(_ctx.categoryChild), 1)
                    ], 64))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "p-the-c01-detail__section__note" }, " 商品は都合により予告なく変更または終了となる場合がございます。予めご了承ください。 ", -1))
    ])
  ]))
}